/**
 * Sales Mode Configuration
 * ICP-focused mode for Sales Account Executives
 * Shows only sales-relevant features and navigation.
 * Landing copy is sourced from marketing-copy.ts (single source of truth).
 */

'use client';

import { ModeConfig } from './config';
import {
  LayoutDashboard,
  ScrollText,
  Settings,
  Mail,
  Video,
  Wrench,
} from 'lucide-react';
import { FileText } from 'lucide-react';
import { TranscribeIcon } from './icons';
import { SageNavIcon } from '@/components/support/sage-nav-icon';
import { getLandingCopy } from '@/lib/marketing-copy';

const salesCopy = getLandingCopy('sales');

export const salesMode: ModeConfig = {
  id: 'sales',
  name: 'Sales',
  sidebarNav: [
    { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard, messageKey: 'app.nav.dashboard', section: 'workspace' },
    { name: 'Transcribe', href: '/dashboard/transcribe', icon: TranscribeIcon, messageKey: 'app.nav.transcribe', section: 'workspace' },
    { name: 'Meetings', href: '/dashboard/meetings', icon: Video, messageKey: 'app.nav.meetings', section: 'workspace' },
    { name: 'Transcripts', href: '/dashboard/transcriptions', icon: ScrollText, messageKey: 'app.nav.transcripts', section: 'workspace' },
    { name: 'Free tools', href: '/dashboard/tools', icon: Wrench, section: 'tools' },
    { name: 'Support', href: '/dashboard/support', icon: SageNavIcon, messageKey: 'app.nav.support', section: 'account' },
    { name: 'Settings', href: '/dashboard/settings', icon: Settings, messageKey: 'app.nav.settings', section: 'account' },
  ],
  transcriptTabs: [
    { id: 'transcript', label: 'Transcript', icon: FileText, messageKey: 'app.tabs.transcript' },
    { id: 'sales-call-kit', label: 'Sales Call Kit', icon: Mail, messageKey: 'app.tabs.salesCallKit' },
  ],
  landingPage: {
    hero: {
      title: salesCopy.hero.heading,
      description: salesCopy.hero.subhead,
      cta: {
        primary: salesCopy.hero.primaryCta.label,
        secondary: salesCopy.hero.secondaryCta?.label,
      },
    },
    features: (salesCopy.features ?? []).map((f) => ({
      title: f.title,
      description: f.description,
    })),
  },
  routes: {
    dashboard: '/dashboard',
    upload: '/dashboard/upload',
    transcriptions: '/dashboard/transcriptions',
    success: '/wisprs/success',
  },
};
